export default __webpack_public_path__ + "static/media/nation id.386e78e3.png";